import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Hero } from "@/components/landing/Hero";
import { StatsBar, Marquee } from "@/components/landing/StatsMarquee";
import { Problem, NaturalAntiAge } from "@/components/landing/ProblemNatural";
import { Method, Evenings } from "@/components/landing/MethodEvenings";
import { Results, Expert } from "@/components/landing/ResultsExpert";
import { Doors } from "@/components/landing/Doors";
import { Speakers, ForWho } from "@/components/landing/SpeakersForWho";
import { Offer, Faq, Closing } from "@/components/landing/OfferFaq";
import { StickyCta } from "@/components/landing/StickyCta";
import { RegistrationSection } from "@/components/form/RegistrationSection";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/api";

export default function Landing() {
  const { search, hash } = useLocation();
  useEffect(() => {
    if (new URLSearchParams(search).get("pagamento") === "annullato") {
      toast("Pagamento annullato. I tuoi dati sono salvati: puoi riprovare quando vuoi.");
    }
    if (hash === "#iscrizione") {
      const t = setTimeout(() => scrollToId("iscrizione"), 500);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [search, hash]);

  return (
    <main data-testid="landing-page">
      <Hero />
      <StatsBar />
      <Marquee />
      <Problem />
      <NaturalAntiAge />
      <Method />
      <Evenings />
      <Results />
      <Expert />
      <Doors />
      <Speakers />
      <ForWho />
      <Offer />
      <RegistrationSection />
      <Faq />
      <Closing />
      <Footer />
      <StickyCta />
    </main>
  );
}
